import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';
import { canActivateResetPasswordPage } from '@core/guards/reset-password.guard';
import { SentryExample } from "./sentry-example.component";

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./@features/orders/orders.module').then((m) => m.OrdersModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./@features/authentication/sign-in/sign-in.module').then(
        (m) => m.SignInModule
      ),
    canActivate: [guestGuard],
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./@features/authentication/sign-up/sign-up.module').then(
        (m) => m.SignUpModule
      ),
    canActivate: [guestGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import(
        './@features/authentication/forgot-password/forgot-password.module'
      ).then((m) => m.ForgotPasswordModule),
    canActivate: [guestGuard],
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import(
        './@features/authentication/reset-password/reset-password.module'
      ).then((m) => m.ResetPasswordModule),
    canActivate: [guestGuard, canActivateResetPasswordPage],
  },
  {
    path: 'auction',
    loadChildren: () =>
      import('./@features/auction/auction.module').then((m) => m.AuctionModule),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./@features/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'code',
    loadChildren: () =>
      import('./@features/code/code.module').then((m) => m.CodeModule),
  },
  {
    path: 'faq',
    loadChildren: () =>
      import('./@features/faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./@features/legal/legal.module').then((m) => m.LegalModule),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./@features/about-us/about-us.module').then(
        (m) => m.AboutUsModule
      ),
  },
  {
    path: 'sentry-test',
    component: SentryExample,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
